const pairs = (digits: string) => digits.match(/.{1,2}/g)?.join(' ') ?? ''

/**
 * A phone number as typed, grouped for reading: `06 12 34 56 78`, `+33 6 12 34 56 78`. Only
 * digits and a leading `+` are kept; other international numbers are not grouped, their country
 * code length being unknown.
 */
export function formatPhone(raw: string): string {
  const plus = raw.trimStart().startsWith('+')
  const digits = raw.replace(/\D/g, '')
  if (!plus) return pairs(digits)
  if (!digits.startsWith('33')) return `+${digits}`
  const national = digits.slice(2)
  return ['+33', national.slice(0, 1), pairs(national.slice(1))].filter(Boolean).join(' ')
}

const isKept = (char: string) => /[\d+]/.test(char)

/**
 * Formats an input's value and moves its caret to follow the same digit. Erasing a space
 * erases the digit before it: the space would come back otherwise.
 */
export function reformat(
  raw: string,
  caret: number,
  erasedBackward: boolean,
  previous: string,
): { value: string; caret: number } {
  let text = raw
  let at = caret
  const count = (s: string) => [...s].filter(isKept).length
  if (erasedBackward && count(text) === count(previous) && at > 0) {
    const before = [...text.slice(0, at)]
    const index = before.findLastIndex(isKept)
    if (index >= 0) {
      text = text.slice(0, index) + text.slice(index + 1)
      at = index
    }
  }
  const kept = count(text.slice(0, at))
  const value = formatPhone(text)
  let position = 0
  for (let seen = 0; position < value.length && seen < kept; position++)
    if (isKept(value[position] as string)) seen++
  return { value, caret: position }
}
